
export default {
  name: "factor",
  layout: "dashboard",
  middleware: 'auth',
}
